export default "__VITE_ASSET__DSvt4A_1__"